import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityInvitationsAcceptReducers, securityInvitationsAcceptWatchers } from './accept';
import { securityInvitationsLinkReducers, securityInvitationsLinkWatchers } from './link';
import { securityInvitationsResendReducers, securityInvitationsResendWatchers } from './resend';
import { securityInvitationsSendReducers, securityInvitationsSendWatchers } from './send';

export const securityInvitationsReducers = combineReducers({
	accept: securityInvitationsAcceptReducers,
	link: securityInvitationsLinkReducers,
	resend: securityInvitationsResendReducers,
	send: securityInvitationsSendReducers
});

export const securityInvitationsWatchers = combineAllWatchers([
	securityInvitationsAcceptWatchers,
	securityInvitationsLinkWatchers,
	securityInvitationsResendWatchers,
	securityInvitationsSendWatchers
]);
